export enum E_FIELDS {
  LENS_MOUNT = 'lens-mount',
  FOCAL_LENGTH = 'focal-length',
  APERTURE = 'aperture',
  LENS_NAME = 'lens-name',
  LENS_FORMAT = 'lens-format',
  FOCUS_TYPE = 'focus-type',
  PRICE = 'price',
}
